/* eslint-disable */


// Programatically generated on Mon Dec 29 2025 15:48:20 GMT+0000
import {fromJS, List, Map, Record, Set} from 'immutable';
import {GenericModel} from 'resources/Generic.model';
import {validate, Empty} from '@albert-io/json-api-framework/models/helpers';
import moment from 'moment';

const ModelConfig = fromJS(
  {
    'endpoint': 'user_feedback_v1',
    'attributes': {
      'sent_email_at': {
        'type': 'datetime',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'user_agent': {
        'type': 'string',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'feedback_type': {
        'type': 'string',
        'isRequired': true,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'reported_device': {
        'type': 'string',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'comment': {
        'type': 'string',
        'isRequired': true,
        'isReadOnly': false,
        'isWriteOnly': false
      },
      'updated_at': {
        'type': 'datetime',
        'isRequired': false,
        'isReadOnly': true,
        'isWriteOnly': false
      },
      'inserted_at': {
        'type': 'datetime',
        'isRequired': false,
        'isReadOnly': true,
        'isWriteOnly': false
      },
      'id': {
        'type': 'binary_id',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      }
    },
    'relationships': {
      'authoring_question_v1': {
        'type': 'one-to-one'
      },
      'user_v1': {
        'type': 'one-to-one'
      },
      'user_v2': {
        'type': 'one-to-one'
      },
      'question_v1': {
        'type': 'one-to-one'
      },
      'question_v2': {
        'type': 'one-to-one'
      },
      'question_v3': {
        'type': 'one-to-one'
      },
      'search_question_v1': {
        'type': 'one-to-one'
      },
      'public_question_v1': {
        'type': 'one-to-one'
      },
      'search_question_v2': {
        'type': 'one-to-one'
      }
    }
  }
);

const ModelRecord = Record(
  {
    'reported_device': Empty,
    'question': Empty,
    'user': Empty,
    'authoring_question': Empty,
    'user_agent': Empty,
    'feedback_type': Empty,
    'updated_at': Empty,
    'inserted_at': Empty,
    'id': Empty,
    'public_question': Empty,
    'relationshipMeta': Empty,
    'sent_email_at': Empty,
    'search_question': Empty,
    'comment': Empty,
    'meta': new Map({
    'populated_metadata_fields': Empty
  })
  }
);

const DefaultModel = fromJS(
  {
    'reported_device': '',
    'user_agent': '',
    'feedback_type': '',
    'id': '',
    'comment': '',
    'updated_at': new Date(),
    'inserted_at': new Date(),
    'sent_email_at': new Date(),
    'meta': new Map(),
    'question': new Map(),
    'user': new Map(),
    'authoring_question': new Map(),
    'public_question': new Map(),
    'relationshipMeta': new Map(),
    'search_question': new Map()
  }
);

export class UserFeedbackModelV1 extends GenericModel(ModelRecord, ModelConfig, 'UserFeedbackModelV1') {
  // -- Query Rules --
  /**
   * @returns {boolean}
   */
  static allowsInclude(include) {
    // AllowedIncludes is currently disabled.
    return true; // AllowedIncludes.has(include);
  }

  /**
   * @returns {boolean}
   */
  static allowsFilter(filterField, filterType) {
    return filterType ?
      FilterRules.get(filterField).has(filterType) :
      FilterRules.has(filterField);
  }

  /**
   * @returns {boolean}
   */
  static allowsSort(sort) {
    return sort.split(',').filter((s) => AllowedSorts.has(s)).length > 0;
  }

  /**
   * @returns {Array}
   */
  static getAllowedSorts() {
    return AllowedSorts.keySeq().toJS();
  }

  static getMetaContextQuery(key) {
    if (!MetadataContextRules.hasIn(['optional', key]) && !MetadataContextRules.hasIn(['required', key])) {
      console.error('Rule for meta context key ' + key + ' does not exist');
    }

    return MetadataContextRules.getIn(['optional', key]) || MetadataContextRules.getIn(['required', key]);
  }

  /**
   * @returns {Immutable.Set}
   */
  static getRequiredMetaContextRules() {
    return new Set([...MetadataContextRules.get('required').values()]);
  }

  /**
   * @returns {Immutable.Set}
   */
  static getAllMetaContextRules() {
    return new Set([...MetadataContextRules.get('required').values(), ...MetadataContextRules.get('optional').values()]);
  }

  static getDefaultModel() {
    _emptyUserFeedbackModelV1Model = _emptyUserFeedbackModelV1Model ? _emptyUserFeedbackModelV1Model : new UserFeedbackModelV1(DefaultModel);
    return _emptyUserFeedbackModelV1Model;
  }

  static supportsMetaContext() {
    return MetadataContextRules !== null;
  }

  /**
   * @returns {string}
   */
  static getModelName() {
    return 'UserFeedbackModelV1';
  }

  /**
   * @returns {boolean}
   */
  static _isFullSpec() {
    return true;
  }

  constructor() {
    super(...arguments);
    this.__meta = null;
  }

  /**
   * @returns {string}
   */
  getJsonApiType() {
    return 'user_feedback_v1';
  }

  /**
   * @params {string} - An attribute name
   * @params {*} [def] - Optional default value override for the attribute
   */
  getValueForAttribute(attribute, def) {
    let value = this.get(attribute);
    validate(value, attribute);
    if (value === Empty) {
      value = def !== undefined ? def : DefaultModel.get(attribute);
    }
    return value;
  }

  // -- Primary Attributes --
  
  /**
   * @type {string}
   */
  getComment() {
    const value = this.getValueForAttribute('comment');
    return value;
  }

  setComment(value) {
    return this.setField('comment', value);
  }

  /**
   * @type {string}
   */
  getFeedbackType() {
    const value = this.getValueForAttribute('feedback_type');
    return value;
  }

  setFeedbackType(value) {
    return this.setField('feedback_type', value);
  }

  /**
   * @type {binary_id}
   */
  getId() {
    const value = this.getValueForAttribute('id');
    return value;
  }

  setId(value) {
    return this.setField('id', value);
  }

  /**
   * @type {datetime}
   */
  getInsertedAt() {
    const value = this.getValueForAttribute('inserted_at');
    
      const momentValue = moment(value);
      return momentValue.isValid() ? momentValue : value;
    
  }

  /**
   * @type {string}
   */
  getReportedDevice() {
    const value = this.getValueForAttribute('reported_device');
    return value;
  }

  setReportedDevice(value) {
    return this.setField('reported_device', value);
  }

  /**
   * @type {datetime}
   */
  getSentEmailAt() {
    const value = this.getValueForAttribute('sent_email_at');
    
      const momentValue = moment(value);
      return momentValue.isValid() ? momentValue : value;
    
  }

  setSentEmailAt(value) {
    const momentValue = moment(value);
    return this.setField('sent_email_at', momentValue.isValid() ? momentValue : value);
  }

  /**
   * @type {datetime}
   */
  getUpdatedAt() {
    const value = this.getValueForAttribute('updated_at');
    
      const momentValue = moment(value);
      return momentValue.isValid() ? momentValue : value;
    
  }

  /**
   * @type {string}
   */
  getUserAgent() {
    const value = this.getValueForAttribute('user_agent');
    return value;
  }

  setUserAgent(value) {
    return this.setField('user_agent', value);
  }

  // -- Meta Attributes --
  
    /**
     * LEGACY META ACCESSORS
     * @todo These should no longer be used, instead use this.getMeta()[...]
     */
    
      getPopulatedMetadataFields() {
        return this.getMeta().getPopulatedMetadataFields();
      }
    
    getMeta() {
      if (this.__meta) {
        return this.__meta;
      }
      const meta = this.get('meta', Map());
      this.__meta = {
        
          /**
           * @type {string[]}
           */
          getPopulatedMetadataFields() {
            const value = meta.get('populated_metadata_fields');
            validate(value, 'populated_metadata_fields');
            return value;
          },
  
      };
      return this.__meta;
    }
  
  // -- Relationships --
  
  /**
   * @type {authoring_question_v1 (one)}
   */
  getAuthoringQuestion() {
    const value = this.getValueForAttribute('authoring_question');
    return value;
  }

  // -- Relationship Fields: authoring_question --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {public_question_v1 (one)}
   */
  getPublicQuestion() {
    const value = this.getValueForAttribute('public_question');
    return value;
  }

  // -- Relationship Fields: public_question --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {question_v3 (one)}
   */
  getQuestion() {
    const value = this.getValueForAttribute('question');
    return value;
  }

  // -- Relationship Fields: question --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {search_question_v2 (one)}
   */
  getSearchQuestion() {
    const value = this.getValueForAttribute('search_question');
    return value;
  }

  // -- Relationship Fields: search_question --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {user_v2 (one)}
   */
  getUser() {
    const value = this.getValueForAttribute('user');
    return value;
  }

  // -- Relationship Fields: user --
  // no 'fields' found, skipped generating accessor(s)
  
}

// -- Empty Model Instance --
let _emptyUserFeedbackModelV1Model = null;

// -- Sort Rules --

const AllowedSorts = fromJS({
  'comment': null,
  'feedback_type': null,
  'id': null,
  'inserted_at': null,
  'reported_device': null,
  'sent_email_at': null,
  'updated_at': null,
  'user_agent': null,
});

// -- Include Rules --
// List []

// -- Filter Rules --
const FilterRules = new Map({
  'authoring_question_v1': new Set(['associated']),
  'comment': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'feedback_type': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix']),
  'id': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'inserted_at': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'meta.populated_metadata_fields': new Set(['null']),
  'public_question_v1': new Set(['associated']),
  'question_v1': new Set(['associated']),
  'question_v2': new Set(['associated']),
  'question_v3': new Set(['associated']),
  'reported_device': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix']),
  'search_question_v1': new Set(['associated']),
  'search_question_v2': new Set(['associated']),
  'sent_email_at': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'updated_at': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'user_agent': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'user_v1': new Set(['associated']),
  'user_v2': new Set(['associated']),
});
    

// -- Metadata Context Rules --
const MetadataContextRules = fromJS({
  optional: {
  },
  required: {
  }
});

// -- Legacy Name Export --
export const UserFeedback = UserFeedbackModelV1;
